import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1540.000000 1426.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1426.000000) scale(0.100000,-0.100000)" >
<path d="M2 7128 l3 -7133 2 7127 3 7128 7698 3 7697 2 -7702 3 -7703 2 2
-7132z"/>
<path d="M7245 13459 c-925 -60 -1784 -279 -2616 -668 -599 -280 -1135 -630
-1669 -1087 -150 -129 -557 -533 -686 -682 -266 -307 -488 -605 -684 -917
-365 -583 -625 -1157 -815 -1802 -264 -892 -353 -1883 -255 -2815 73 -685 240
-1203 518 -1603 48 -70 80 -110 192 -239 90 -103 362 -305 525 -388 276 -141
641 -243 1030 -287 431 -49 1198 -39 1910 24 1605 142 1900 160 2660 160 783
-1 1113 -23 2455 -165 982 -104 1337 -130 1855 -137 796 -11 1243 53 1733 246
146 58 409 211 517 301 126 107 248 230 330 335 434 557 644 1378 645 2518 0
993 -187 1918 -573 2837 -64 152 -255 542 -328 670 -219 385 -466 751 -698
1035 -675 827 -1477 1468 -2421 1934 -864 428 -1794 673 -2763 730 -203 13
-670 12 -862 0z m1445 -1540 c8 -5 45 -22 82 -38 112 -49 301 -164 353 -216
25 -24 59 -114 63 -167 4 -50 0 -65 -38 -145 -23 -48 -50 -99 -60 -113 -10
-14 -26 -41 -37 -60 -17 -31 -67 -111 -113 -180 -15 -23 -68 -113 -177 -302
-23 -40 -56 -100 -74 -133 -17 -33 -52 -91 -77 -130 -46 -70 -58 -90 -150
-265 -28 -52 -58 -108 -66 -124 -9 -16 -16 -35 -16 -42 0 -24 70 -36 175 -30
280 16 526 17 749 5 231 -12 266 -19 266 -48 0 -12 -62 -72 -91 -87 -43 -22
-260 -241 -310 -313 -73 -105 -100 -153 -95 -167 4 -12 86 -14 461 -14 514 0
514 0 515 -71 0 -21 -28 -55 -122 -152 -68 -69 -157 -165 -199 -213 -115 -135
-244 -331 -264 -400 -12 -43 7 -46 277 -40 320 8 298 8 528 1 219 -7 250 -14
250 -59 0 -24 -28 -57 -178 -205 -98 -97 -186 -189 -196 -204 -17 -28 -24 -38
-77 -101 -52 -63 -142 -221 -143 -251 l-1 -30 485 -5 c507 -6 532 -8 545 -50
9 -28 17 -19 -220 -246 -66 -62 -265 -310 -327 -405 -26 -40 -38 -69 -36 -87
l3 -27 325 0 c309 -1 501 -13 558 -36 47 -18 29 -53 -87 -172 -60 -62 -124
-131 -143 -154 -18 -23 -69 -86 -113 -140 -72 -89 -135 -176 -135 -187 0 -2
-22 -43 -50 -91 -28 -48 -50 -90 -50 -94 0 -4 -15 -23 -33 -43 -25 -28 -45
-38 -87 -47 -50 -10 -489 -13 -1110 -8 l-185 2 -3 -40 c-6 -86 -63 -165 -160
-222 -58 -33 -203 -106 -267 -134 -88 -38 -400 -132 -490 -148 -27 -5 -95 -21
-150 -36 -55 -14 -145 -31 -200 -36 -187 -17 -210 -20 -268 -30 -32 -5 -97
-10 -145 -10 -48 0 -184 -3 -302 -6 -377 -9 -784 17 -1035 68 -83 17 -297 66
-372 85 -75 20 -109 13 -131 -27 -9 -17 -67 -106 -128 -199 -106 -161 -144
-226 -144 -248 0 -6 -6 -17 -13 -24 -7 -7 -25 -29 -40 -50 -16 -20 -43 -44
-62 -52 -19 -9 -48 -36 -64 -60 -31 -45 -62 -73 -151 -141 -52 -39 -170 -135
-180 -145 -6 -6 -82 -72 -146 -127 -189 -161 -240 -184 -271 -123 -15 29 -17
120 -4 170 6 19 12 76 15 125 6 98 19 213 35 315 6 36 11 104 11 152 0 58 4
90 13 95 6 4 12 24 13 43 3 110 20 161 99 295 32 55 67 116 77 135 10 19 36
67 58 105 97 174 101 185 98 287 -3 93 -3 93 45 190 26 54 47 100 47 103 0 4
14 26 30 51 17 24 37 63 46 86 8 22 18 46 23 52 9 11 81 153 156 309 20 42 53
96 72 119 19 23 41 55 50 72 8 17 21 38 28 46 16 19 98 175 115 220 8 19 16
37 20 40 3 3 41 77 84 165 89 180 105 204 192 295 34 36 68 81 75 100 8 19 30
66 50 105 122 237 168 328 197 390 61 130 90 176 157 246 36 39 73 86 82 105
9 19 20 34 25 34 4 0 8 6 8 14 0 7 15 39 34 69 18 31 44 84 56 117 12 33 27
63 31 66 5 3 9 12 9 20 0 22 81 194 91 194 5 0 9 6 9 14 0 24 100 208 133 243
11 12 32 25 46 28 36 8 79 49 87 83 6 25 70 160 138 291 7 14 30 60 51 102 42
88 82 130 142 149 63 20 85 50 218 305 37 72 73 137 79 145 7 8 18 26 24 40 7
14 26 47 43 74 16 26 44 76 61 110 28 53 46 85 105 181 7 11 26 47 43 80 17
33 44 80 60 105 16 25 39 63 51 85 12 22 39 63 60 92 22 29 39 55 39 58 0 3
25 44 55 90 30 47 55 88 55 90 0 3 24 46 53 96 83 143 89 154 96 159 4 3 26
38 50 78 52 86 118 148 175 163 23 5 46 12 51 14 13 5 65 -5 85 -16z m-6230
-6475 c163 -28 331 -101 471 -205 149 -110 181 -175 118 -238 -50 -50 -91 -44
-170 25 -81 71 -129 104 -204 141 -264 132 -575 132 -840 1 -56 -28 -175 -111
-221 -155 -30 -30 -59 -43 -94 -43 -54 0 -101 66 -86 124 17 69 253 237 416
297 204 74 389 90 610 53z m9464 -20 c14 -5 16 -43 16 -315 0 -267 -2 -310
-15 -315 -8 -4 -22 -1 -30 6 -13 10 -15 52 -15 249 l-1 236 -33 -55 c-19 -30
-43 -65 -54 -77 -24 -26 -52 -21 -52 8 0 22 152 269 165 269 2 0 10 -3 19 -6z
m184 -6 c9 -9 12 -77 12 -246 0 -128 4 -231 8 -228 5 3 19 26 32 51 31 61 65
96 84 89 28 -11 17 -42 -54 -158 -77 -125 -90 -139 -114 -130 -14 5 -16 39
-16 314 0 305 1 315 31 319 3 1 10 -4 17 -11z m1110 -180 c9 -9 12 -167 12
-650 0 -620 -1 -638 -19 -648 -11 -5 -63 -10 -116 -10 -53 0 -105 5 -116 10
-18 10 -19 28 -19 655 0 505 3 644 13 648 27 11 233 7 245 -5z m-10800 -114
c147 -30 268 -92 369 -189 55 -54 63 -65 63 -98 0 -61 -63 -109 -122 -93 -13
3 -54 31 -91 61 -117 95 -193 124 -339 132 -181 10 -302 -29 -442 -142 -84
-67 -121 -73 -167 -24 -55 59 -36 114 69 198 176 141 433 202 660 155z m10400
-728 c2 -353 0 -451 -10 -458 -19 -11 -216 -10 -239 2 -18 10 -19 26 -19 454
0 243 3 446 7 450 4 3 63 5 132 4 l126 -3 3 -449z m-10433 420 c62 -16 105
-38 172 -88 60 -44 73 -63 73 -110 0 -44 -22 -74 -65 -88 -42 -14 -70 -6 -111
30 -17 15 -53 37 -80 50 -96 47 -240 26 -315 -46 -37 -35 -84 -46 -124 -29
-40 16 -55 41 -55 91 0 31 7 45 45 81 49 47 125 89 195 109 60 16 203 17 265
0z m852 -203 c51 -54 93 -104 93 -112 0 -20 -30 -51 -49 -51 -9 0 -37 20 -61
45 -24 25 -48 45 -52 45 -4 0 -9 -87 -10 -192 l-3 -193 -36 -3 c-32 -3 -37 0
-43 23 -4 15 -6 102 -6 193 0 92 1 171 0 176 0 6 -22 -14 -48 -44 -41 -46 -51
-52 -74 -47 -29 8 -44 38 -31 61 4 8 47 55 95 105 60 62 95 91 110 91 16 0 51
-30 115 -97z m9171 -337 c2 -257 -1 -331 -10 -338 -7 -4 -61 -8 -120 -8 -84 0
-110 3 -122 16 -14 13 -16 57 -16 328 0 233 3 315 12 324 9 9 48 12 133 10
l120 -3 3 -329z m-10068 194 c53 -38 73 -111 46 -173 -23 -54 -59 -80 -118
-84 -62 -5 -106 18 -138 69 -46 76 -1 188 85 211 33 9 96 -3 125 -23z m440 1
c6 -12 10 -96 10 -203 l1 -183 39 42 c51 54 74 67 99 54 23 -13 34 -38 24 -55
-5 -7 -47 -54 -94 -105 -63 -68 -92 -91 -110 -91 -19 0 -50 25 -118 94 -78 80
-92 99 -89 123 2 23 8 29 34 31 26 3 36 -4 68 -42 21 -26 42 -46 47 -46 5 0 9
78 9 188 0 133 4 192 12 200 18 18 56 14 68 -7z m9220 -350 c0 -154 -2 -180
-16 -185 -9 -3 -62 -6 -119 -6 -81 0 -107 3 -119 16 -13 13 -16 42 -16 162 0
81 3 157 6 170 6 21 10 22 135 22 l129 0 0 -179z"/>
<path d="M8191 11374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8208 11358 c-7 -13 -18 -32 -24 -43 -6 -11 -16 -19 -22 -18 -7 2 -9
-4 -5 -15 3 -9 2 -14 -2 -10 -11 10 -38 -29 -30 -42 4 -6 -1 -7 -11 -3 -12 4
-15 3 -10 -5 4 -6 0 -25 -9 -41 -8 -17 -15 -41 -15 -56 0 -25 -23 -35 -35 -15
-8 13 -25 3 -25 -15 0 -7 7 -21 16 -29 9 -9 13 -24 9 -35 -5 -16 -12 -19 -39
-14 -27 4 -36 1 -50 -18 -21 -31 -20 -52 4 -74 27 -24 4 -47 -39 -39 -69 14
-13 -54 99 -119 71 -42 38 -31 -57 18 -93 49 -121 55 -129 28 -3 -10 -10 -26
-15 -35 -11 -22 -3 -23 17 -3 21 20 46 19 70 -3 11 -10 26 -16 33 -14 9 3 11
0 6 -8 -6 -10 -4 -12 8 -7 24 9 86 -24 87 -46 0 -10 -33 -76 -74 -145 -40 -70
-98 -172 -128 -227 -62 -113 -101 -181 -213 -375 -42 -74 -96 -169 -118 -210
-22 -41 -48 -87 -59 -102 -10 -14 -18 -33 -18 -42 0 -21 50 -125 275 -581 101
-203 213 -433 250 -510 78 -162 200 -413 342 -705 55 -113 110 -225 121 -250
11 -25 93 -193 182 -375 89 -181 190 -388 225 -460 34 -71 129 -265 210 -430
81 -165 160 -328 176 -362 29 -59 32 -62 72 -67 78 -9 550 -13 917 -7 389 7
423 11 426 56 2 27 33 98 48 108 6 5 2 6 -11 2 -15 -4 -25 0 -32 12 -6 10 -11
12 -11 6 0 -8 -13 -13 -30 -13 l-30 0 0 80 c0 64 3 80 15 80 11 0 15 11 15 40
0 29 -4 40 -15 40 -12 0 -15 20 -15 116 l0 116 -42 40 c-24 23 -38 43 -32 45
9 3 9 10 0 28 -9 20 -19 25 -48 25 -26 0 -38 4 -38 14 0 8 -6 21 -14 28 -7 8
-17 28 -20 45 -7 31 -46 57 -77 53 -8 -2 -59 -1 -114 0 l-100 3 95 8 c104 10
150 24 150 46 0 10 -13 14 -47 13 -61 -1 -174 15 -199 28 -11 6 -48 14 -83 18
-48 5 -65 11 -68 24 -3 10 -22 26 -44 35 -21 10 -39 22 -39 27 0 4 -16 8 -35
8 -19 0 -35 5 -35 10 0 6 5 10 10 10 6 0 10 14 10 30 0 25 -4 30 -24 30 -25 0
-33 16 -50 92 -3 14 -17 39 -30 55 -20 24 -27 47 -36 134 -6 57 -14 113 -17
124 -7 25 -25 37 -34 24 -4 -7 -13 -4 -23 6 -9 10 -31 21 -49 26 -108 27 -132
37 -114 44 10 4 16 13 13 20 -3 10 21 12 106 11 82 -1 112 2 115 11 13 33 -41
56 -173 73 -97 13 -195 40 -187 53 3 5 23 7 44 5 26 -2 40 1 44 10 9 24 5 112
-5 112 -5 0 -10 18 -10 40 0 34 -3 40 -21 40 -15 0 -19 5 -15 15 3 9 -4 21
-19 31 -14 9 -25 22 -25 29 0 19 -94 110 -129 125 -17 7 -31 19 -31 26 0 7 -8
27 -19 44 -13 23 -17 43 -13 80 3 36 1 50 -8 50 -7 0 -10 6 -7 14 4 10 -5 16
-34 21 -21 4 -41 10 -44 15 -8 14 57 31 92 24 20 -4 33 -2 33 4 0 6 -26 13
-57 15 -46 2 -39 4 32 6 236 7 152 18 -170 22 -289 4 -358 8 -395 22 -39 14
-133 36 -287 68 -73 15 -92 36 -84 97 1 6 -4 12 -11 12 -8 0 -22 14 -31 30
-10 17 -22 30 -28 30 -5 0 -9 11 -9 24 0 12 -12 45 -26 72 -15 27 -27 60 -28
74 -2 36 -29 90 -44 90 -8 0 -12 6 -9 13 2 6 -5 22 -16 35 -11 12 -22 30 -23
40 -5 39 -14 67 -24 70 -8 3 70 162 92 187 6 6 198 12 520 15 l510 5 30 54
c83 148 295 388 415 467 122 82 108 89 -194 98 -270 9 -325 9 -619 0 -251 -8
-304 -3 -304 29 0 13 7 32 15 45 9 12 32 54 52 94 19 40 62 121 94 179 33 58
59 108 59 111 0 4 -13 10 -28 16 -16 5 -64 32 -108 59 -43 27 -113 68 -155 91
-80 44 -219 142 -201 142 20 0 167 -84 249 -143 46 -32 120 -79 165 -103 76
-41 84 -43 95 -27 7 9 13 22 13 29 0 6 7 17 16 25 8 7 28 40 44 74 16 34 36
67 44 74 20 17 20 37 1 45 -8 3 -15 10 -15 15 0 14 140 255 150 259 31 12 -64
84 -185 142 -38 18 -78 37 -87 42 -11 5 -18 4 -18 -1 0 -5 6 -11 12 -13 9 -3
-2 -35 -35 -99 -26 -52 -47 -100 -47 -107 0 -7 -11 -17 -25 -22 -14 -5 -25
-16 -25 -25 0 -31 -60 -12 -111 34 -31 29 -32 31 -11 31 17 0 22 6 22 28 0 15
9 43 20 62 11 19 26 46 33 60 6 13 24 38 40 54 15 17 27 37 27 44 0 9 7 11 23
7 19 -5 18 -3 -8 20 -67 58 -211 145 -241 145 -7 0 -19 -10 -26 -22z m224
-524 c22 -21 23 -34 3 -34 -18 0 -19 -12 -3 -28 20 -20 -10 -15 -51 10 -60 35
-112 90 -100 104 8 9 23 7 71 -12 34 -13 69 -31 80 -40z m-115 -46 c23 -15 45
-33 48 -38 17 -28 -70 11 -120 55 l-30 25 30 -6 c17 -4 49 -20 72 -36z m-46
-39 c24 -12 62 -37 83 -57 37 -33 38 -35 13 -28 -21 5 -27 3 -27 -10 0 -46
-114 36 -124 89 -6 33 -2 33 55 6z m401 -111 c-7 -7 -12 -8 -12 -2 0 14 12 26
19 19 2 -3 -1 -11 -7 -17z m-72 -128 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3
6 -1 10 4 10 6 0 11 -4 11 -10z m-277 -87 c-25 -49 -55 -100 -65 -115 -10 -14
-18 -29 -18 -32 0 -3 -13 -27 -28 -53 -16 -27 -55 -95 -87 -153 -32 -58 -78
-138 -102 -178 -23 -40 -43 -76 -43 -80 0 -4 -11 -23 -23 -42 -13 -19 -41 -66
-62 -105 -58 -107 -136 -247 -150 -270 -7 -11 -29 -51 -50 -88 -20 -38 -39
-67 -41 -65 -4 4 112 221 187 350 22 36 39 70 39 74 0 4 26 50 58 103 32 53
85 143 117 201 32 58 95 170 140 250 46 80 95 170 110 200 25 50 52 90 62 90
2 0 -18 -39 -44 -87z m1964 -3679 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17
-2 13 -5z m146 -131 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z"/>
<path d="M7576 10353 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M7560 10320 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0
-15 -4 -15 -10z"/>
<path d="M7502 10160 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M7462 10135 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15
-21z"/>
<path d="M7414 10038 c-4 -7 -14 -23 -22 -35 -9 -15 -10 -23 -3 -23 6 0 11 5
11 12 0 6 7 20 17 30 9 10 14 21 11 24 -3 3 -9 -1 -14 -8z"/>
<path d="M7320 9960 c-8 -5 -25 -10 -36 -10 -44 0 -46 -24 -6 -63 l37 -36 1
25 c1 14 11 35 22 47 29 32 16 59 -18 37z"/>
<path d="M7473 9778 c0 -7 -4 -22 -8 -33 -7 -20 -6 -20 9 -1 17 21 21 46 8 46
-5 0 -9 -6 -9 -12z"/>
<path d="M7196 9704 c-3 -9 -6 -23 -6 -32 0 -9 -7 -30 -16 -47 -13 -26 -42
-122 -74 -245 -5 -19 -19 -66 -30 -105 -12 -38 -24 -81 -27 -95 -3 -14 -11
-38 -18 -55 -7 -16 -21 -73 -31 -125 -9 -52 -23 -108 -31 -125 l-14 -30 4 30
c3 28 1 31 -24 27 -24 -4 -26 -6 -19 -35 14 -58 48 -146 113 -292 26 -60 364
-732 432 -860 26 -49 74 -137 105 -195 31 -58 79 -148 106 -200 26 -52 57
-111 69 -130 12 -19 49 -88 83 -153 34 -64 66 -125 72 -135 5 -9 47 -87 93
-172 46 -85 99 -182 117 -215 18 -33 57 -107 88 -165 30 -58 66 -122 79 -142
13 -21 23 -40 23 -42 0 -3 52 -101 116 -218 163 -299 168 -307 203 -366 17
-29 31 -55 31 -58 0 -9 63 -74 72 -74 4 0 8 7 8 15 0 19 26 20 33 1 5 -12 12
-12 54 0 50 15 71 29 60 41 -4 4 -13 1 -19 -5 -17 -17 -45 -15 -52 4 -3 8 -10
12 -16 9 -5 -3 -10 1 -10 9 0 9 7 16 15 16 8 0 15 9 15 20 0 11 5 20 11 20 5
0 8 4 4 9 -3 5 -1 12 5 16 14 9 13 175 -1 175 -7 0 -10 30 -8 90 2 49 0 92 -4
96 -4 4 -7 0 -7 -9 0 -10 -8 -17 -19 -17 -16 0 -20 11 -26 74 -3 41 -13 83
-20 93 -8 10 -15 30 -15 45 0 16 -13 42 -30 61 -16 19 -30 42 -30 50 0 9 -4
19 -10 22 -5 3 -10 26 -10 51 0 24 -4 44 -8 44 -15 0 -32 49 -32 91 0 22 -9
59 -20 81 -11 23 -20 57 -20 75 0 19 -7 44 -15 57 -15 23 -30 76 -54 189 l-12
57 -40 0 c-28 0 -39 4 -39 15 0 8 -4 15 -9 15 -5 0 -11 10 -14 23 -12 49 -40
117 -48 117 -5 0 -9 9 -9 20 0 11 -5 20 -11 20 -18 0 -39 27 -39 50 0 12 5 18
10 15 6 -3 10 -1 10 4 0 6 -11 11 -25 11 -15 0 -25 6 -25 14 0 18 -46 101 -65
116 -19 16 -19 30 0 30 18 0 18 1 1 42 -8 18 -20 52 -27 76 -7 23 -18 42 -26
42 -7 0 -13 7 -13 15 0 27 -23 65 -40 65 -19 0 -35 32 -47 93 -5 21 -12 37
-17 36 -14 -1 -26 25 -14 32 8 5 6 12 -5 24 -10 9 -17 24 -17 33 0 25 -38 82
-52 80 -7 -2 -13 6 -13 17 -1 11 -13 46 -29 78 -15 32 -26 68 -26 80 4 43 0
66 -14 79 -7 8 -17 48 -21 89 -6 63 -42 182 -65 214 -4 6 -13 28 -19 50 -12
39 -37 96 -71 165 -10 19 -23 53 -29 75 -7 22 -23 65 -36 95 -13 30 -36 87
-51 125 -16 39 -31 72 -34 75 -3 3 -12 21 -19 40 -8 19 -32 73 -53 120 -22 47
-49 105 -60 130 -11 25 -26 58 -35 74 -20 36 -72 178 -84 231 -15 61 -48 87
-63 49z"/>
<path d="M7426 9701 c-4 -6 -3 -11 3 -11 6 0 8 -8 5 -17 -5 -16 -4 -16 6 0 8
13 9 22 2 29 -6 6 -12 6 -16 -1z"/>
<path d="M7380 9694 c0 -12 32 -65 36 -61 9 9 -8 56 -22 61 -8 3 -14 3 -14 0z"/>
<path d="M6861 9317 c-14 -7 -33 -32 -44 -60 -33 -80 -11 -74 56 15 40 54 36
70 -12 45z"/>
<path d="M7920 9160 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6338 8403 c-35 -38 -65 -120 -34 -94 19 16 87 131 78 131 -5 0 -24
-17 -44 -37z"/>
<path d="M10460 8432 c0 -4 9 -13 20 -20 18 -11 20 -10 20 8 0 13 -7 20 -20
20 -11 0 -20 -3 -20 -8z"/>
<path d="M5885 7586 c-35 -16 -67 -49 -89 -91 -15 -28 -14 -30 4 -37 11 -4 23
-16 27 -25 9 -27 43 -103 46 -103 1 0 1 28 1 62 -1 35 2 71 7 81 6 11 6 17 -1
17 -18 0 -11 22 15 46 14 13 25 32 25 44 0 11 -1 20 -2 20 -2 -1 -16 -7 -33
-14z"/>
<path d="M9688 7593 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M10140 7590 l-35 -7 38 -2 c22 0 36 -5 32 -11 -4 -6 73 -9 219 -9
130 1 223 5 220 10 -3 5 29 9 72 9 43 0 75 2 72 5 -8 8 -581 13 -618 5z m417
-16 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M9920 7586 c0 -8 71 -12 76 -4 3 4 -13 8 -35 8 -23 0 -41 -2 -41 -4z"/>
<path d="M10855 7580 c17 -4 26 -8 20 -9 -5 -1 -4 -5 4 -10 11 -7 9 -14 -10
-34 -13 -13 -35 -37 -49 -52 -23 -26 -24 -27 -3 -16 12 6 25 16 28 21 3 6 13
10 22 10 22 0 74 56 67 74 -5 14 -50 27 -88 25 -15 -1 -13 -3 9 -9z"/>
<path d="M6631 7553 c-1 -12 12 -42 29 -66 16 -24 46 -82 65 -127 33 -77 74
-158 132 -257 19 -33 22 -43 10 -43 -8 0 -20 13 -27 30 -14 33 -49 69 -37 37
4 -11 3 -16 -3 -12 -6 4 -23 -7 -39 -24 -26 -28 -60 -44 -46 -22 9 16 -9 20
-23 5 -7 -8 -11 -14 -8 -14 3 0 -2 -21 -10 -47 -19 -61 -9 -365 12 -399 8 -11
11 -24 7 -27 -3 -4 -2 -7 4 -7 6 0 16 -28 23 -62 7 -35 19 -70 26 -79 8 -8 14
-23 14 -32 0 -9 5 -19 10 -22 6 -3 10 -15 10 -25 0 -10 6 -20 13 -23 7 -2 0
-15 -20 -34 -18 -17 -29 -33 -26 -37 3 -3 -1 -6 -9 -6 -9 0 -19 6 -21 13 -4 9
-8 9 -15 -2 -8 -11 -16 -7 -39 18 -17 17 -35 31 -42 31 -6 0 -11 5 -11 10 0 6
-11 10 -25 10 -17 0 -25 5 -25 18 0 9 -10 22 -22 27 -16 7 -27 26 -37 63 -8
28 -19 52 -25 52 -6 0 -23 12 -38 28 -14 15 -31 32 -37 37 -6 6 -21 22 -32 38
-13 16 -30 27 -45 27 -22 0 -23 3 -14 20 9 17 8 20 -10 20 -13 0 -24 10 -30
25 -5 14 -16 25 -25 25 -8 0 -15 5 -15 11 0 5 -4 8 -9 4 -15 -9 -31 29 -24 56
6 21 5 23 -10 10 -15 -12 -17 -11 -17 3 0 10 -3 15 -8 12 -4 -2 -16 16 -26 40
-10 24 -22 44 -27 44 -5 0 -9 -2 -9 -5 0 -9 61 -126 85 -165 12 -20 46 -81 75
-135 28 -55 55 -104 60 -110 4 -5 18 -28 30 -50 13 -22 44 -78 70 -125 70
-124 189 -333 200 -350 6 -8 13 -22 17 -30 4 -8 40 -73 81 -145 41 -71 85
-152 99 -180 23 -45 23 -48 5 -32 -11 10 -23 29 -26 43 -4 13 -11 24 -17 24
-6 0 -9 -9 -6 -19 3 -14 1 -18 -9 -14 -10 4 -11 10 -3 25 8 15 7 24 -4 36 -8
9 -18 28 -22 41 -6 21 -9 22 -23 8 -11 -12 -12 -19 -4 -29 16 -20 36 -76 22
-62 -16 16 -48 6 -55 -16 -3 -10 -12 -21 -20 -24 -20 -7 -19 -46 0 -46 17 0
19 -9 6 -29 -5 -7 -14 -11 -19 -7 -13 8 -36 -30 -27 -44 6 -10 -22 -71 -38
-81 -5 -4 -8 -25 -5 -48 l4 -41 -38 0 c-21 0 -38 -4 -38 -10 0 -5 8 -10 18
-10 14 0 15 -2 2 -9 -8 -6 -18 -7 -24 -4 -5 3 -6 1 -2 -5 4 -7 20 -12 37 -12
16 0 29 -4 29 -9 0 -32 730 -48 1045 -23 280 22 310 27 299 43 -3 6 -15 9 -25
6 -11 -3 -19 -1 -19 4 0 5 5 9 10 9 6 0 10 5 10 10 0 6 -7 10 -16 10 -12 0
-14 8 -9 44 6 39 2 55 -35 133 -23 48 -48 95 -55 103 -7 8 -15 28 -19 44 -4
16 -18 43 -30 60 -13 17 -40 70 -61 118 -20 48 -43 93 -51 99 -8 7 -12 20 -9
30 5 13 2 17 -7 14 -15 -6 -21 4 -54 85 -10 25 -21 47 -24 50 -10 9 -110 215
-110 227 0 6 -7 16 -15 23 -15 13 -115 209 -115 227 0 7 -6 18 -13 25 -45 44
-188 312 -202 375 -3 18 -11 31 -16 30 -5 -1 -24 30 -43 68 -19 39 -37 69 -41
67 -3 -1 -21 26 -39 60 -63 121 -91 168 -98 168 -14 0 -47 33 -42 42 6 10 -46
79 -97 128 -20 19 -39 42 -42 50 -4 10 -6 8 -6 -7z m1076 -1975 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M10600 7239 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M10512 7143 c-27 -30 -27 -33 -2 -33 13 0 22 9 26 25 9 36 3 38 -24
8z"/>
<path d="M6020 7043 c0 -7 16 -38 35 -70 37 -62 44 -66 20 -12 -18 44 -55 98
-55 82z"/>
<path d="M10403 6983 c-4 -9 -18 -27 -31 -38 -15 -13 -23 -28 -20 -40 4 -17 7
-15 17 12 7 17 19 34 26 37 18 7 40 46 25 46 -6 0 -14 -8 -17 -17z"/>
<path d="M10325 6869 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5381 6738 c-46 -57 -58 -88 -43 -113 7 -14 18 -2 56 63 25 45 46 86
46 92 0 22 -20 8 -59 -42z"/>
<path d="M10394 6772 c3 -5 -9 -7 -27 -5 l-32 4 33 -15 c17 -8 32 -22 32 -31
0 -11 11 -15 40 -15 33 0 40 3 40 20 0 13 5 18 15 14 11 -4 13 -2 9 9 -5 15
-46 27 -91 27 -13 0 -22 -4 -19 -8z"/>
<path d="M10624 6768 c-6 -10 245 -9 268 0 10 4 -45 7 -123 7 -77 0 -143 -3
-145 -7z"/>
<path d="M10906 6759 c-60 -9 -86 -19 -48 -19 11 0 23 -6 26 -12 3 -10 8 -9
18 2 10 11 35 15 100 15 47 0 86 -2 86 -5 -2 -23 4 -31 18 -26 14 5 15 4 5 -8
-8 -10 -9 -16 -1 -21 5 -3 10 0 10 7 0 8 5 5 11 -5 8 -14 8 -22 0 -30 -19 -19
-12 -31 8 -13 32 29 31 52 -3 87 -26 27 -27 30 -7 20 12 -7 32 -11 42 -8 12 3
24 -2 33 -15 10 -14 15 -16 19 -6 5 11 7 11 15 -1 7 -10 11 -10 17 -1 11 18
-5 27 -76 39 -75 13 -186 13 -273 0z"/>
<path d="M10568 6753 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M10648 6743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M10703 6743 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M11043 6565 c0 -25 4 -40 8 -34 4 7 5 19 1 27 -4 11 -1 14 10 10 17
-7 21 23 4 34 -20 14 -24 8 -23 -37z"/>
<path d="M11005 6511 c-3 -10 -13 -18 -22 -17 -12 1 -18 -8 -20 -27 -1 -24 1
-26 12 -17 8 6 19 9 24 5 7 -3 8 0 5 10 -4 11 -2 14 9 9 11 -4 14 2 13 25 -1
35 -12 41 -21 12z m-15 -25 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11
10 11 6 0 10 -2 10 -4z"/>
<path d="M10896 6411 c-15 -6 -16 -10 -7 -15 8 -5 20 -2 29 8 17 17 9 19 -22
7z"/>
<path d="M10882 6361 c4 -13 18 -16 19 -4 0 4 -5 9 -11 12 -7 2 -11 -2 -8 -8z"/>
<path d="M10850 6333 c14 -3 29 -10 33 -17 6 -7 7 -6 4 4 -2 8 -16 16 -33 17
-25 1 -26 0 -4 -4z"/>
<path d="M5384 6228 c-38 -18 -67 -40 -75 -57 -7 -14 -21 -35 -30 -46 -26 -29
-68 -185 -64 -234 1 -23 10 -50 19 -60 9 -10 14 -25 10 -35 -3 -9 -1 -16 5
-16 6 0 11 -17 11 -40 0 -29 4 -40 15 -40 20 0 19 -17 -2 -29 -14 -8 -15 -12
-4 -25 7 -9 10 -24 7 -33 -4 -10 -4 -14 0 -10 9 9 54 -32 54 -50 0 -9 -11 -6
-37 10 -21 13 -74 41 -118 62 -44 22 -88 48 -99 58 -22 19 -36 22 -36 8 0 -13
63 -61 79 -61 7 0 9 -4 6 -10 -4 -6 5 -10 19 -10 32 0 32 -9 5 -63 -37 -72
-171 -310 -195 -347 -13 -19 -24 -38 -24 -42 0 -4 -14 -30 -31 -58 -37 -60
-34 -89 17 -156 29 -38 32 -45 15 -39 -18 5 -21 2 -21 -20 0 -15 -16 -62 -36
-104 -20 -42 -49 -110 -64 -151 -39 -106 -120 -284 -131 -288 -5 -2 -6 -8 -3
-14 4 -6 -4 -9 -17 -7 -42 5 -69 -10 -69 -37 0 -14 -6 -40 -14 -59 -24 -56
-24 -100 0 -109 19 -7 66 16 121 61 48 39 59 63 43 93 -7 13 -7 20 0 20 16 0
90 71 130 125 40 55 50 65 224 233 64 62 116 119 116 127 0 23 19 18 57 -15
18 -16 43 -30 55 -30 34 0 112 88 161 182 25 48 78 134 119 193 40 58 88 133
106 166 18 32 45 67 58 76 29 19 59 15 232 -31 57 -15 110 -25 118 -22 17 6 5
30 -98 194 -33 51 -62 100 -66 110 -7 16 -21 40 -101 162 -20 30 -38 60 -41
65 -6 12 -69 109 -120 185 -21 30 -40 64 -44 75 -3 11 -19 36 -36 55 -16 19
-30 39 -30 45 0 5 -5 4 -11 -2 -9 -9 20 -79 49 -117 5 -6 22 -36 38 -66 16
-30 31 -57 34 -60 7 -7 30 -60 26 -60 -1 0 -29 41 -62 90 -32 50 -61 90 -65
90 -3 0 -20 30 -37 68 -30 63 -81 133 -99 132 -4 -1 -36 -15 -69 -32z m386
-419 c0 -6 -4 -7 -10 -4 -5 3 -10 11 -10 16 0 6 5 7 10 4 6 -3 10 -11 10 -16z
m-302 -461 c-57 -106 -240 -432 -255 -453 -35 -52 -6 13 57 125 38 69 104 187
147 262 42 76 78 136 81 134 2 -3 -11 -33 -30 -68z"/>
<path d="M10780 6250 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M5530 6245 c0 -15 18 -40 24 -34 3 3 -1 14 -9 25 -8 10 -14 15 -15 9z"/>
<path d="M10747 6215 c-4 -8 -3 -16 1 -19 4 -3 9 4 9 15 2 23 -3 25 -10 4z"/>
<path d="M10732 6130 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M10655 6090 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M10640 6040 c0 -16 3 -17 25 -7 32 15 32 22 0 23 -18 1 -25 -3 -25
-16z"/>
<path d="M4985 5710 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4930 5635 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z"/>
<path d="M4917 5604 c-4 -4 -7 -14 -7 -23 0 -11 3 -12 11 -4 6 6 10 16 7 23
-2 6 -7 8 -11 4z"/>
<path d="M4746 5295 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M6325 5260 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M6448 5243 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4890 5169 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4867 5157 c-3 -8 -1 -20 4 -28 6 -10 9 -7 9 14 0 29 -5 35 -13 14z"/>
<path d="M4834 5121 c4 -5 0 -12 -6 -14 -10 -4 -10 -6 0 -6 6 -1 12 -5 12 -10
0 -16 -53 -19 -92 -5 -43 15 -54 -1 -10 -17 60 -23 151 14 117 48 -15 15 -29
18 -21 4z"/>
<path d="M4582 4630 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5467 1859 c-53 -13 -118 -59 -152 -111 -25 -36 -30 -55 -33 -120 -3
-65 -1 -84 19 -124 79 -159 311 -193 440 -64 87 87 101 210 36 308 -68 100
-182 141 -310 111z m153 -127 c70 -51 78 -161 17 -218 -63 -58 -151 -50 -201
19 -28 39 -28 126 0 164 45 62 126 77 184 35z"/>
<path d="M9980 1858 c-53 -15 -91 -47 -112 -94 -16 -37 -17 -50 -8 -84 16 -59
51 -86 144 -110 45 -11 91 -25 104 -30 24 -10 29 -39 10 -58 -19 -19 -127 -14
-177 8 -24 11 -45 20 -48 20 -2 0 -13 -21 -25 -47 -20 -45 -20 -47 -2 -60 45
-33 187 -51 261 -34 95 23 153 99 137 180 -10 47 -48 78 -128 102 -128 38
-141 44 -145 64 -8 43 84 60 169 30 23 -8 44 -15 45 -15 1 0 10 21 20 47 17
44 17 47 0 59 -41 30 -175 42 -245 22z"/>
<path d="M4030 1615 l0 -245 195 0 195 0 0 55 0 55 -125 0 -125 0 0 45 0 45
105 0 105 0 0 50 0 50 -108 0 -108 0 4 40 4 40 119 0 119 0 0 55 0 55 -190 0
-190 0 0 -245z"/>
<path d="M4460 1848 c0 -6 34 -116 76 -245 l76 -233 73 0 74 0 46 145 c26 80
48 145 50 145 2 0 25 -65 51 -145 l46 -145 73 0 73 0 57 178 c31 97 65 201 76
230 29 81 28 82 -43 82 l-63 0 -50 -157 -49 -156 -14 34 c-15 37 -57 169 -74
237 l-11 42 -66 0 -66 -1 -48 -149 c-26 -83 -51 -150 -55 -150 -4 0 -27 68
-52 150 l-45 150 -67 0 c-45 0 -68 -4 -68 -12z"/>
<path d="M5890 1615 l0 -245 70 0 70 0 0 65 0 65 38 0 c35 0 40 -4 81 -65 l44
-65 74 0 73 0 -51 74 -51 74 40 40 c97 97 52 253 -83 291 -22 6 -100 11 -172
11 l-133 0 0 -245z m280 115 c12 -12 20 -33 20 -54 0 -48 -28 -66 -102 -66
l-58 0 0 70 0 70 60 0 c47 0 64 -4 80 -20z"/>
<path d="M6410 1615 l0 -245 185 0 185 0 0 55 0 55 -115 0 -115 0 0 190 0 190
-70 0 -70 0 0 -245z"/>
<path d="M6830 1615 l0 -245 138 0 c205 0 287 32 338 132 23 45 26 61 22 127
-3 62 -8 83 -29 114 -63 92 -135 117 -331 117 l-138 0 0 -245z m267 129 c65
-13 112 -88 96 -154 -19 -80 -64 -110 -165 -110 l-63 0 0 135 0 135 51 0 c28
0 65 -3 81 -6z"/>
<path d="M7610 1614 l0 -246 158 4 c173 4 219 16 276 74 98 100 86 283 -23
359 -64 44 -120 55 -273 55 l-138 0 0 -246z m300 117 c42 -22 63 -61 63 -116
0 -89 -55 -135 -162 -135 l-61 0 0 135 0 135 63 0 c41 0 74 -6 97 -19z"/>
<path d="M8318 1818 c-9 -24 -57 -134 -106 -246 l-90 -203 70 3 71 3 16 43
c18 51 27 54 141 50 l85 -3 23 -47 22 -48 71 0 c39 0 68 3 66 8 -5 8 -25 51
-87 192 -23 52 -61 138 -85 190 l-42 95 -69 3 -69 3 -17 -43z m117 -169 c15
-38 26 -72 24 -74 -4 -3 -95 -8 -111 -6 -3 1 5 29 18 64 34 83 36 87 39 87 2
0 15 -32 30 -71z"/>
<path d="M8660 1805 l0 -55 75 0 75 0 0 -190 0 -190 70 0 70 0 0 190 0 190 75
0 75 0 0 55 0 55 -220 0 -220 0 0 -55z"/>
<path d="M9280 1850 c0 -6 -20 -54 -44 -108 -23 -53 -63 -142 -87 -197 -24
-55 -51 -116 -61 -135 l-16 -35 60 -3 c34 -2 66 -1 72 1 6 3 17 22 25 43 8 22
19 42 25 46 20 13 193 9 204 -4 5 -7 15 -30 23 -50 l13 -38 72 0 72 0 -90 203
c-49 111 -97 221 -106 245 l-16 42 -73 0 c-44 0 -73 -4 -73 -10z m105 -201
c15 -38 25 -72 22 -75 -2 -3 -30 -4 -60 -2 l-55 3 30 73 c17 39 32 72 33 72 1
0 14 -32 30 -71z"/>
<path d="M10332 1677 c3 -181 3 -184 31 -225 41 -62 94 -86 193 -87 73 0 85 3
129 30 33 20 56 44 71 75 22 42 23 58 24 218 l0 172 -65 0 -65 0 0 -157 c0
-179 -6 -200 -62 -221 -32 -12 -40 -12 -72 3 -48 23 -56 56 -56 233 l0 142
-66 0 -65 0 3 -183z"/>
<path d="M10880 1615 l0 -245 150 0 c188 0 239 10 280 56 25 29 30 43 30 84 0
41 -5 53 -31 79 -17 17 -36 31 -42 31 -6 0 2 13 18 30 20 21 29 42 33 78 4 45
2 50 -32 79 -50 45 -90 53 -258 53 l-148 0 0 -245z m290 131 c18 -22 8 -59
-20 -73 -14 -7 -49 -13 -77 -13 l-53 0 0 50 0 50 69 0 c48 0 72 -4 81 -14z
m23 -186 c17 -19 16 -51 -2 -69 -18 -18 -34 -21 -96 -21 l-75 0 0 51 0 51 84
-3 c46 -2 86 -6 89 -9z"/>
<path d="M4475 748 c-15 -79 -30 -153 -33 -165 -4 -23 -3 -23 107 -23 129 0
183 16 206 61 20 38 19 62 -4 90 -18 23 -18 23 6 42 20 16 23 27 21 61 -4 60
-41 76 -174 76 l-100 0 -29 -142z m209 56 c11 -28 -13 -44 -65 -44 -51 0 -52
1 -43 38 5 19 13 22 54 22 35 0 50 -4 54 -16z m-11 -123 c8 -8 9 -16 1 -29 -9
-13 -25 -17 -70 -17 -62 0 -65 4 -48 54 5 17 99 10 117 -8z"/>
<path d="M5726 748 c-15 -79 -30 -153 -33 -165 -5 -23 -4 -23 104 -23 96 0
115 3 159 25 70 35 99 82 99 161 0 56 -3 66 -29 93 -38 39 -80 51 -186 51
l-85 0 -29 -142z m187 61 c49 -13 65 -44 49 -97 -17 -55 -41 -72 -108 -79
l-57 -6 6 44 c3 24 11 68 17 97 13 58 21 61 93 41z"/>
<path d="M7766 748 c-15 -79 -30 -153 -33 -165 -5 -23 -5 -23 121 -23 119 0
126 1 128 20 4 56 8 54 -69 51 -86 -3 -84 -7 -53 129 29 127 29 130 -23 130
l-43 0 -28 -142z"/>
<path d="M8046 748 c-15 -79 -30 -153 -33 -165 -5 -23 -5 -23 125 -23 138 0
142 1 142 51 0 17 -8 19 -80 19 l-80 0 0 30 0 29 78 3 77 3 3 33 3 32 -72 0
c-69 0 -71 1 -65 23 3 12 6 25 6 30 0 4 38 7 85 7 61 0 85 3 85 13 0 6 3 22 6
35 6 22 6 22 -122 22 l-129 0 -29 -142z"/>
<path d="M8413 871 c-84 -53 -68 -160 27 -177 19 -4 45 -13 58 -21 20 -12 21
-17 11 -30 -10 -11 -26 -14 -69 -10 -30 3 -64 8 -76 12 -15 5 -23 0 -32 -20
-17 -38 -16 -42 21 -53 102 -32 179 -20 227 35 55 62 29 120 -66 148 -56 16
-78 40 -53 56 18 12 81 11 112 0 22 -9 27 -6 41 22 10 21 12 35 5 42 -5 6 -47
11 -92 13 -68 2 -87 0 -114 -17z"/>
<path d="M8713 871 c-39 -24 -53 -49 -53 -94 0 -42 20 -62 91 -85 40 -14 54
-24 54 -38 0 -16 -7 -19 -55 -19 -30 1 -67 4 -81 9 -23 6 -28 4 -39 -24 -16
-38 -9 -44 66 -60 102 -21 193 19 209 92 10 45 -20 79 -91 103 -46 15 -59 25
-59 40 0 16 8 21 44 23 23 2 56 -1 72 -7 26 -9 29 -7 44 22 22 43 9 51 -88 55
-68 2 -87 0 -114 -17z"/>
<path d="M9106 748 c-15 -79 -30 -153 -33 -165 -5 -21 -2 -23 41 -23 48 0 49
1 58 65 3 17 13 21 75 25 106 7 153 49 153 136 0 31 -6 48 -25 66 -30 31 -63
38 -164 38 l-77 0 -28 -142z m185 62 c12 -7 19 -21 19 -40 0 -36 -23 -50 -80
-50 -35 0 -41 3 -36 18 2 9 7 32 11 50 6 27 11 32 36 32 17 0 39 -5 50 -10z"/>
<path d="M9436 749 c-16 -79 -31 -154 -34 -166 -4 -21 -1 -23 42 -23 48 0 49
1 58 65 2 13 12 21 28 23 21 2 29 -5 50 -43 24 -44 26 -45 73 -45 l49 0 -27
46 -27 45 37 32 c41 36 56 84 43 133 -13 52 -49 68 -163 72 l-101 4 -28 -143z
m185 61 c12 -7 19 -21 19 -40 0 -36 -23 -50 -80 -50 -35 0 -41 3 -36 18 2 9 7
32 11 50 6 27 11 32 36 32 17 0 39 -5 50 -10z"/>
<path d="M9782 733 c-17 -87 -32 -161 -32 -165 0 -5 20 -8 45 -8 38 0 45 3 50
23 19 88 55 275 55 289 0 14 -9 18 -43 18 l-42 0 -33 -157z"/>
<path d="M10035 876 c-62 -28 -115 -110 -115 -179 0 -42 34 -95 78 -120 60
-35 181 -21 220 26 9 11 6 19 -13 37 -25 23 -26 23 -54 7 -36 -21 -80 -22
-109 -1 -17 12 -22 25 -22 60 0 56 12 79 50 99 37 19 65 19 100 -1 26 -16 29
-16 59 5 25 18 29 25 20 39 -6 10 -23 23 -37 30 -34 16 -139 15 -177 -2z"/>
<path d="M10286 748 c-15 -79 -30 -153 -33 -165 -5 -23 -5 -23 125 -23 138 0
142 1 142 51 0 17 -8 19 -80 19 l-80 0 0 30 0 29 78 3 77 3 3 33 3 32 -72 0
c-69 0 -71 1 -65 23 3 12 6 25 6 30 0 4 38 7 85 7 77 0 85 2 85 19 0 11 3 26
6 35 5 14 -9 16 -123 16 l-128 0 -29 -142z"/>
<path d="M5410 851 c0 -32 -11 -51 -30 -51 -12 0 -19 -10 -22 -30 -4 -25 -1
-30 15 -30 15 0 18 -5 13 -25 -4 -14 -9 -45 -12 -69 -8 -59 19 -86 87 -86 26
0 51 5 54 11 10 15 -4 60 -18 58 -40 -5 -45 8 -26 74 8 32 14 37 38 37 24 0
29 5 33 30 4 25 1 29 -21 32 -23 3 -26 7 -23 36 3 32 3 32 -42 32 -39 0 -46
-3 -46 -19z"/>
<path d="M6460 851 c0 -32 -11 -51 -30 -51 -12 0 -19 -10 -22 -30 -4 -25 -1
-30 15 -30 15 0 18 -5 13 -25 -4 -14 -9 -45 -12 -69 -8 -59 19 -86 87 -86 26
0 51 5 54 11 10 15 -4 60 -18 58 -40 -5 -45 8 -26 74 9 32 14 37 39 37 19 0
30 5 30 14 0 8 3 21 6 29 4 11 -2 16 -23 19 -25 3 -28 6 -25 36 3 32 3 32 -42
32 -39 0 -46 -3 -46 -19z"/>
<path d="M7450 851 c0 -33 -11 -51 -31 -51 -14 0 -19 -7 -19 -30 0 -21 5 -30
16 -30 12 0 15 -6 10 -25 -4 -14 -9 -45 -12 -69 -8 -59 19 -86 87 -86 26 0 51
5 54 11 10 15 -4 60 -18 58 -35 -4 -39 1 -33 39 12 66 16 72 46 72 22 0 29 5
33 28 6 32 7 31 -24 35 -20 3 -24 9 -21 36 3 31 3 31 -42 31 -39 0 -46 -3 -46
-19z"/>
<path d="M4902 812 c-12 -4 -38 -22 -57 -40 -62 -62 -55 -161 15 -197 53 -27
180 -13 180 20 0 7 -8 19 -18 29 -15 13 -24 14 -49 6 -36 -13 -83 2 -83 25 0
14 13 16 83 15 45 -1 88 -1 95 -1 16 1 16 58 -1 91 -23 46 -99 70 -165 52z
m96 -84 c3 -15 -4 -18 -47 -18 -37 0 -51 4 -51 14 0 19 17 25 60 23 24 -1 36
-7 38 -19z"/>
<path d="M5183 810 c-34 -11 -73 -53 -73 -79 0 -33 30 -59 80 -71 30 -7 50
-17 50 -26 0 -16 -48 -19 -96 -5 -29 8 -33 6 -44 -17 -10 -22 -9 -28 6 -39 22
-16 120 -17 163 -2 37 13 65 60 57 94 -6 23 -67 55 -106 55 -11 0 -20 7 -20
15 0 19 32 23 91 11 21 -4 29 0 38 21 7 16 8 30 3 35 -14 14 -113 19 -149 8z"/>
<path d="M6162 803 c-91 -45 -108 -194 -26 -232 33 -15 97 -14 112 1 9 9 12 9
12 0 0 -20 78 -15 84 6 8 23 46 214 46 228 0 13 -83 7 -88 -6 -2 -4 -15 -2
-30 6 -35 18 -69 17 -110 -3z m99 -63 c24 -13 26 -66 2 -92 -38 -42 -103 -8
-89 47 12 48 47 66 87 45z"/>
<path d="M6680 801 c-54 -29 -74 -63 -74 -127 0 -51 3 -59 32 -85 34 -31 85
-39 123 -19 13 7 19 7 19 0 0 -5 18 -10 39 -10 29 0 41 5 45 18 7 22 46 217
46 229 0 4 -20 7 -45 5 -25 -2 -45 -8 -45 -12 0 -5 -12 -2 -27 6 -38 19 -71
18 -113 -5z m101 -61 c26 -14 26 -71 0 -94 -23 -21 -70 -18 -84 5 -20 31 14
99 49 99 9 0 24 -5 35 -10z"/>
<path d="M7144 806 c-83 -36 -109 -158 -47 -220 28 -28 87 -35 124 -16 13 7
19 7 19 0 0 -5 18 -10 40 -10 37 0 40 2 49 38 10 36 41 198 41 211 0 3 -20 5
-45 3 -25 -2 -45 -8 -45 -12 0 -5 -12 -2 -27 6 -34 17 -69 17 -109 0z m97 -66
c24 -13 26 -66 2 -92 -24 -27 -71 -24 -85 7 -13 29 5 81 30 88 28 8 33 7 53
-3z"/>
<path d="M10576 644 c-19 -18 -21 -55 -4 -72 15 -15 61 -15 76 0 7 7 12 24 12
38 0 14 -5 31 -12 38 -17 17 -54 15 -72 -4z"/>
<path d="M10708 646 c-21 -15 -24 -56 -6 -74 15 -15 61 -15 76 0 7 7 12 24 12
38 0 46 -44 66 -82 36z"/>
<path d="M10837 642 c-34 -37 -15 -82 33 -82 33 0 50 17 50 50 0 49 -51 68
-83 32z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
